export interface RecommendedProduct {
  id: string;
  name: string;
  description: string;
  imageThumbnailUrl: string;
  oncePrice: number;
  monthlyPrice: number;
  minimumPrice: number;
  maximumPrice: number;
  monthlyMinimumPrice: number;
  monthlyMaximumPrice: number;
  grantAmount: number;
}

export interface Product {
  id: string;
  code: string;
  name: string;
  media: Media[];
  prices: Price[];
  highlights: string[];
  description: string;
  highLevelDescription: string;
  classification: Classification;
  attributes: ProductAttributes;
}

export interface ProductAttributes {
  amountSolarPanels: number;
  grantAmountAvailable: number;
}

export interface Media {
  mediaFiles: MediaFile[];
  id: string;
  mediaType: string;
  mimeType?: string;
  modified?: Date | string;
  description?: string;
  created?: Date | string;
}

export interface MediaFile {
  created?: Date | string;
  id: string;
  mediaId: string;
  modified?: Date | string;
  sizeType: string;
  url: string;
}

export enum EMediaType {
  Image = "Image",
  Video = "Video"
}

export enum ESizeType {
  Thumbnail = "Thumbnail",
  Original = "Original"
}

export interface Price {
  price: number;
  roundingMethod: string;
  taxId: string;
  vatRate: number;
  stripePriceId?: number;
  paymentType?: string;
  xeroAccountCodeId?: string;
  xeroAccountCode?: string;
}

export enum EPricePaymentType {
  Once = "Once",
  Monthly = "Monthly",
  Annually = "Annually"
}

export interface Classification {
  id: string;
  created: Date | string;
  modified: Date | string;
  code: string;
  name: string;
}
